export default __webpack_public_path__ + "656f87de14c7d6722782144c482ad01e.svg";